// extracted by mini-css-extract-plugin
export default {"container":"forgot-password_container__8i2Vt","header":"forgot-password_header__9kMcQ","info":"forgot-password_info__G+b-6","button":"forgot-password_button__ak3I7"};